'use strict';

exports.__esModule = true;
exports.parseParams = parseParams;
exports.initAnimate = initAnimate;
var DEFAULT_PARAMS = {
    autoAlpha: 0,
    ease: Power3.easeOut
};
var DEFAULT_DURATION = 1.8;
var DEFAULT_STAGGER = .1;

var counter = 0;

function parseParams(str) {
    if (!str) {
        return {};
    }

    var data = {};

    str.split(',').forEach(function (item) {
        var _item$split = item.split(':'),
            key = _item$split[0],
            value = _item$split[1];

        data[key] = value;
    });

    return data;
}

// 动画初始化函数
function initAnimate() {
    var map = {};

    $('[data-animate]').each(function (i, item) {
        var $item = $(item);
        var data = $item.data();
        var params = parseParams(data.params);

        if (!data.animate) {
            data.animate = ++counter;
        }

        if (!map[data.animate]) {
            map[data.animate] = [];
        }

        var tm = TweenMax.from($item, params.dur || DEFAULT_DURATION, $.extend({}, DEFAULT_PARAMS, params));

        tm.pause();

        map[data.animate].push(tm);
    });

    return map;
}


//////////////////
// WEBPACK FOOTER
// ../src/js/animate.js
// module id = 0
// module chunks = 0